import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoader = defineStore('loader', () => {
    const loading = ref(false);
    const requestsPending = ref(0);

    const show = () => {
        loading.value = true;
    };

    const hide = () => {
        loading.value = false;
    };

    const pending = () => {
        if (requestsPending.value === 0) {
            loading.value = true;
        }

        requestsPending.value++;
    };

    /**
     * @param {Promise} fn
     * @return Promise
     */
    const pendingTask = async (fn) => {
        pending();

        try {
            await fn;
        } finally {
            done();
        }
    };

    /**
     * @param {Promise[]} arr
     * @return Promise
     */
    const pendingTasks = async (arr) => {
        pending();

        try {
            await Promise.all(arr);
        } finally {
            done();
        }
    };

    const done = () => {
        if (requestsPending.value >= 1) {
            requestsPending.value--;
        }

        if (requestsPending.value <= 0) {
            loading.value = false;
        }
    };

    return {
        loading,
        requestsPending,
        show,
        hide,
        pending,
        pendingTask,
        pendingTasks,
        done,
    };
});
